import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Breadcrumbs::Item @route=\"index\" @text={{t \"vagrant.product-name\"}} />\n<Page::Registries @registries={{@model.registries}} @pagination={{@model.pagination}} />", {
  moduleName: "vagrant/templates/registries/index.hbs"
});